// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "meta_ad_daily_insights".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "meta_ad_daily_insights" table (1:1 with a DB row, on the wire). */
export const metaAdDailyInsightsAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    adAccountId: z.string(),
    metaCampaignId: z.string(),
    metaAdSetId: z.string().nullable(),
    metaAdId: z.string(),
    adName: z.string().nullable(),
    objective: z.string().nullable(),
    optimizationGoal: z.string().nullable(),
    date: z.string(),
    accountTimezone: z.string().nullable(),
    breakdownType: z.string(),
    breakdownKey: z.string(),
    currency: z.string(),
    spend: z.number(),
    impressions: z.number(),
    reach: z.number(),
    frequency: z.number().nullable(),
    clicks: z.number(),
    uniqueClicks: z.number().nullable(),
    linkClicks: z.number(),
    uniqueLinkClicks: z.number().nullable(),
    outboundClicks: z.number().nullable(),
    uniqueOutboundClicks: z.number().nullable(),
    leads: z.number(),
    messagingConversations: z.number(),
    landingPageViews: z.number(),
    videoPlays: z.number().nullable(),
    video3sViews: z.number().nullable(),
    video2sContinuous: z.number().nullable(),
    videoThruplays: z.number().nullable(),
    video30s: z.number().nullable(),
    videoP25: z.number().nullable(),
    videoP50: z.number().nullable(),
    videoP75: z.number().nullable(),
    videoP95: z.number().nullable(),
    videoP100: z.number().nullable(),
    videoAvgWatchSeconds: z.number().nullable(),
    actions: z.unknown().nullable(),
    costPerActionType: z.unknown().nullable(),
    raw: z.unknown().nullable(),
    fetchedAt: z.string().datetime(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=metaAdDailyInsights.js.map